import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EligibleVoucherData, VoucherInitialState } from "./types";
import * as thunks from "./thunks";

const initialState: VoucherInitialState = {
  isLoading: false,
  selectedVoucher: {},
  eligibleVoucherList: [],
};

const selectVoucherAction = (
  state: VoucherInitialState,
  { payload }: PayloadAction<EligibleVoucherData>
) => {
  state.selectedVoucher = payload;
};

const removeSelectedVoucherAction = (state: VoucherInitialState) => {
  state.selectedVoucher = {};
};

const slice = createSlice({
  name: "voucher",
  initialState,
  reducers: {
    selectVoucherAction,
    removeSelectedVoucherAction,
  },
  extraReducers(builder) {
    builder.addCase(thunks.getEligibleVoucherListThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(thunks.getEligibleVoucherListThunk.rejected, (state) => {
      state.isLoading = false;
      console.error("failed to fetched vouchers");
    });
    builder.addCase(
      thunks.getEligibleVoucherListThunk.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        state.eligibleVoucherList = payload?.originalData?.data || [];
      }
    );
  },
});

export const reducer = slice.reducer;
export const actions = {
  ...slice.actions,
  ...thunks,
};
